import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DynamicHooksComponent } from 'ngx-dynamic-hooks';
import { LinkComponent } from 'link';
import { ImageTextSlice } from './image-text.slice';

@Component({
  selector: 'app-image-text',
  templateUrl: './image-text.component.html',
  styleUrls: ['./image-text.component.scss'],
  standalone: true,
  imports: [DynamicHooksComponent, LinkComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageTextComponent {
  @Input() slice: ImageTextSlice;
  @Input() lazyLoadImage = true;
}
